export interface Translations {
  [locale: string]: Record<typeof translationsKeyList[number], string>;
}

export const translationsKeyList = ['UpdateYourBrowser', 'YourBrowserIsOutdated', 'Update'];
